/**
 * Функция для скачивания файла по заданному URL.
 *
 * @param {string} fileUrl - URL файла для скачивания.
 * @param {string} fileName - Имя файла, которое будет установлено при скачивании.
 */
export const downloadFile = (fileUrl: string) => {
	// Создание временной ссылки
	let url = ''
	const protocol = window.location.protocol
	const host = window.location.hostname
	const port = window.location.port ? `:${window.location.port}` : ''
	const wsPath = ''
	url = `${protocol}//${host}${port}${wsPath}`

	console.log('url', url + fileUrl)

	const link = document.createElement('a')
	link.href = url + fileUrl
	link.setAttribute('download', '')

	// Добавление ссылки в DOM
	document.body.appendChild(link)

	// Программный клик по ссылке для начала скачивания
	link.click()

	// Удаление ссылки из DOM
	document.body.removeChild(link)
}

export const customBase64Uploader = async (event: any) => {
	return new Promise((resolve, reject) => {
		const file = event.files[0]
		const reader = new FileReader()

		reader.onload = function (e) {
			const dataURL = e.target?.result as unknown as string

			if (dataURL) {
				const content = dataURL.split(',')[1]
				resolve(content)
			} else {
				reject()
			}
		}

		reader.readAsDataURL(file)
	})
}
